import TableData from "./TableData";;
import ListData from "./ListData";

const sharedCiphersComponents = {
  TableData,
  ListData,
}

export default sharedCiphersComponents;